export const MIXED_SPORTS = [
  {id:'floorball',label:'Innebandy',api:'/floorball/api'},
  {id:'hockey',label:'Hockey',api:'/hockey/api/hq'},
  {id:'football',label:'Fotboll',api:'/football/api/hq'},
];
export const readMixedStorage = (key, fallback) => {
  try { return JSON.parse((window.SportsHQSettings || window.localStorage).getItem(key)) ?? fallback; } catch { return fallback; }
};
export const stockholmToday = () => new Intl.DateTimeFormat('sv-SE',{
  timeZone:'Europe/Stockholm',year:'numeric',month:'2-digit',day:'2-digit',
}).format(new Date());
export const shiftMixedDate = (date, days) => {
  const value=new Date(date+'T12:00:00Z'); value.setUTCDate(value.getUTCDate()+days);
  return value.toISOString().slice(0,10);
};
export const validMixedDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '')
  && !Number.isNaN(Date.parse(value+'T12:00:00Z'))
  && new Date(value+'T12:00:00Z').toISOString().slice(0,10) === value;
export const mixedStartMinutes = game => {
  const parts=/^(\d{1,2}):(\d{2})$/.exec(game.time || '');
  return game.kickoff_known !== false && parts && +parts[1]<24 && +parts[2]<60
    ? +parts[1]*60 + +parts[2] : Infinity;
};
export const mixedLeagueKey = game => `${game.sport.id}:${game.simulation || game.status?.competition_id || game.league}`;
export const mixedProtected = (game, hidden) => {
  const sport=game.sport.id, cache=readMixedStorage('sports-hq-push-state',{});
  const key=sport==='floorball'?`floorball:innebandy:${game.id}`:`hockey:${game.simulation}:${game.match_id}`;
  return Boolean(hidden || readMixedStorage(`${sport}-hq-hide-results`,false)
    || cache.protection?.hidden?.[sport]
    || cache.preferences?.sports?.[sport]?.matches?.some(row=>row.id===key && row.watch_later)
    || window.SportsHQPush?.protectedMatch(key,sport));
};
export function mixedScore(game, date, hidden) {
  const status=game.status || {};
  const home=status.home_goals ?? game.home_goals, away=status.away_goals ?? game.away_goals;
  const time=Number.isFinite(mixedStartMinutes(game))?game.time:'Tid ej klar';
  if (hidden) return {text:time,label:'Resultat dolt'};
  if (home != null && away != null) return {text:`${home} – ${away}`,label:status.status_id===1?'':status.label || (game.official_final?'Slut':'')};
  if (/inställd|uppskjuten|cancel|postpon/i.test(status.label || '')) return {text:time,label:status.label};
  if (date<stockholmToday()) return {text:'–',label:'Resultat saknas'};
  return {text:time,label:''};
}
